import { Box, BoxProps, Heading, HStack, Text, useTheme } from '@chakra-ui/react';
import { useToken } from '@chakra-ui/react';
import { useLivestreamData } from '@components/Event/provider/LivestreamDataProvider';
import SiteBrand from '@components/SiteBrand';
import { fromToScheduleString } from '@lib/data-transform/event-schedules';
import { commaSeperatedSpeakerNames } from '@lib/data-transform/speakers';
import { motion } from 'framer-motion';
import { FunctionComponent, useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { hexToRGBA } from 'theme';

const MotionBox = motion(Box);

const LiveTicker: FunctionComponent<BoxProps & {}> = () => {
    const { currentProgram } = useLivestreamData();
    const [visible, setVisible] = useState(currentProgram ? true : false);
    const [highlightColor]: string[] = useToken('colors', ['highlight']);
    const { logo } = useTheme();
    const logoUrl = logo || '/examples/logo.png';

    useEffect(() => {
        setVisible(true);
        reset();
        return pause;
    }, [currentProgram]);

    const handleOnIdle = () => {
        setVisible(false);
    };

    const handleOnAction = () => {
        setVisible(true);
    };
    const { reset, pause } = useIdleTimer({
        timeout: 4000,
        onIdle: handleOnIdle,
        onAction: handleOnAction,
        debounce: 500
    });
    return visible && currentProgram ? (
        <MotionBox
            position="absolute"
            top="0"
            left="0"
            w="full"
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -50, opacity: 0 }}
            transitionTimingFunction="ease-out"
            p="4"
            pb="8"
            color="white"
            bg={`linear-gradient(180deg, ${hexToRGBA(highlightColor, 0.5)} 75%, ${hexToRGBA(
                highlightColor,
                0
            )} 100%)`}>
            <HStack spacing="4" align="flex-start">
                <Box width={{ base: 20, sm: 24 }} mt="1">
                    {logoUrl ? (
                        <SiteBrand>
                            <SiteBrand.Logo src={logoUrl} />
                        </SiteBrand>
                    ) : null}
                </Box>
                <Box>
                    <Text fontSize="sm">{fromToScheduleString(currentProgram)} Uhr</Text>
                    <Heading mb="0" as="h2" size="sm">
                        {currentProgram ? currentProgram.title : null}
                    </Heading>
                    <Text>{commaSeperatedSpeakerNames(currentProgram.speakers)}</Text>
                </Box>
            </HStack>
        </MotionBox>
    ) : null;
};

export default LiveTicker;
